// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Carousel__container-c2e154 {
  position: relative;
  width: 100%;
  --prev-button-transform: translate(8px);
  --next-button-transform: translate(-8px);
  --prev-button-wrapper-left: 0;
  --next-button-wrapper-right: 0;
}

:root[dir=rtl] .Carousel__container-c2e154 {
  --prev-button-transform: translate(-8px);
  --next-button-transform: translate(8px);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Carousel/Carousel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EAEA,uCAAA;EACA,wCAAA;EACA,6BAAA;EACA,8BAAA;AAAF;;AAGA;EACE,wCAAA;EACA,uCAAA;AAAF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n\n  --prev-button-transform: translate(8px);\n  --next-button-transform: translate(-8px);\n  --prev-button-wrapper-left: 0;\n  --next-button-wrapper-right: 0;\n}\n\n:root[dir='rtl'] .container {\n  --prev-button-transform: translate(-8px);\n  --next-button-transform: translate(8px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Carousel__container-c2e154`
};
module.exports = ___CSS_LOADER_EXPORT___;
